import application from 'application';

class AudioVideoObserver {

  constructor(meetingRoom) {
    this.meetingRoom = meetingRoom;
  }

  async audioVideoDidStart() {

    this.meetingRoom.unmountSpinner();
    this.meetingRoom.mountControls();
    this.meetingRoom.updateVideoDisplay();
    this.meetingRoom.el.dispatchEvent(new CustomEvent('audio-video-did-started'));

  }

  audioVideoDidStartConnecting(reconnecting) {}

  async audioVideoDidStop(sessionStatus) {

    const { MeetingSessionStatusCode } = await import('amazon-chime-sdk-js');

    const sessionStatusCode = sessionStatus.statusCode();
    if (sessionStatusCode === MeetingSessionStatusCode.Left) {
      console.log('You left the session');
    } else if (sessionStatusCode === MeetingSessionStatusCode.MeetingEnded) {
      console.log('Meeting ended by host');
      this.meetingRoom.onMeetingEnded();
    } else {
      console.log('Stopped with a session status code: ', sessionStatusCode);
    }

  }

  videoTileDidUpdate(videoTileState) {

    if (videoTileState.isContent === true && videoTileState.active === false) {
      this.meetingRoom.unbindScreenTile();
    }
    const isOwnerTile = videoTileState.boundExternalUserId === this.meetingRoom.meeting.ownerId;

    if (isOwnerTile === false) {
      this.meetingRoom.updateVideoDisplay();
      return;
    }

    if (videoTileState.isContent === true) {
      this.meetingRoom.bindScreenTile(videoTileState);
    } else if (videoTileState.isContent === false && this.meetingRoom.ownerVideoTileId === null) {
      this.meetingRoom.bindCameraTile(videoTileState);
    }
    if (videoTileState.isContent === false && videoTileState.active === false) {
      this.meetingRoom.unbindCameraTile();
    }

    this.meetingRoom.updateVideoDisplay();

  }

  videoTileWasRemoved(tileId) {

    if (tileId === this.meetingRoom.ownerScreenVideoTileId) {
      this.meetingRoom.unbindScreenTile();
    } else if (tileId === this.meetingRoom.ownerVideoTileId) {
      this.meetingRoom.unbindCameraTile();
    }

    this.meetingRoom.updateVideoDisplay();

  }

  videoAvailabilityDidChange(availability) {

  }

  connectionDidSuggestStopVideo() {}

}

export default AudioVideoObserver;